"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _dataparcels = _interopRequireDefault(require("dataparcels"));

var _default = function _default(params) {
  var handleChange = function handleChange(newParcel, changeRequest) {
    var result = params.onSideEffect(newParcel, changeRequest);

    if (params.onSideEffectUseResult) {
      var _newParcel$_changeAnd = newParcel._changeAndReturn(function (newParcel) {
        return newParcel.set(result);
      }),
          _newParcel$_changeAnd2 = (0, _slicedToArray2["default"])(_newParcel$_changeAnd, 2),

      /*parcel*/
      changeRequestWithResult = _newParcel$_changeAnd2[1];

      changeRequestWithResult._originId = changeRequest._originId;
      changeRequestWithResult._originPath = changeRequest._originPath;
      changeRequest = changeRequestWithResult;
    }

    params.parcel.dispatch(changeRequest);
  };

  var parcelWithSideEffect = params.parcel._boundarySplit({
    handleChange: handleChange
  });

  return [parcelWithSideEffect, undefined];
};

exports["default"] = _default;